import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { INCENTIVE_MONTHLY } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

export const fetchIncentiveMonthlyTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(INCENTIVE_MONTHLY.GET_MONTHLY_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitIncentiveMonthlyFilterData = async (data = array()) => {
  try {
    const response = await POST(INCENTIVE_MONTHLY.SUBMIT_MONTHLY_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const generateIncentiveMonthly = async () => {
  try {
    const response = await GET(INCENTIVE_MONTHLY.GET_MONTHLY_GENERATE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getIncentiveMonthlyDetails = async (id = "") => {
  try {
    const url = `${INCENTIVE_MONTHLY.GET_MONTHLY_DETAILS}/${id}/details`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getIncentiveMonthlyCandidates = async (incentiveClientDetailsId = "") => {
  try {
    const url = `${INCENTIVE_MONTHLY.GET_MONTHLY_DETAILS}/${incentiveClientDetailsId}/candidates`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchIncentiveMonthlyTwoTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(INCENTIVE_MONTHLY.GET_MONTHLY_TWO_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitIncentiveMonthlyTwoFilterData = async (data = array()) => {
  try {
    const response = await POST(INCENTIVE_MONTHLY.SUBMIT_MONTHLY_TWO_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getIncentiveMonthlyTwoDetails = async (id = "") => {
  try {
    const url = `${INCENTIVE_MONTHLY.GET_MONTHLY_TWO_DETAILS}/${id}/details`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getIncentiveMonthlyTwoCandidates = async (incentiveClientDetailsId = "") => {
  try {
    const url = `${INCENTIVE_MONTHLY.GET_MONTHLY_TWO_DETAILS}/${incentiveClientDetailsId}/candidates`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchIncentiveMonthlyThreeTableAndFilterSchema = async (data = array()) => {
  try {
    const response = await GET(INCENTIVE_MONTHLY.GET_MONTHLY_THREE_METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitIncentiveMonthlyThreeFilterData = async (data = array()) => {
  try {
    const response = await POST(INCENTIVE_MONTHLY.SUBMIT_MONTHLY_THREE_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const generateIncentiveMonthlyThree = async () => {
  try {
    const response = await GET(INCENTIVE_MONTHLY.GET_MONTHLY_THREE_GENERATE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getIncentiveMonthlyThreeDetails = async (id = "") => {
  try {
    const url = `${INCENTIVE_MONTHLY.GET_MONTHLY_THREE_DETAILS}/${id}/details`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getIncentiveMonthlyThreeCandidates = async (incentiveClientDetailsId = "") => {
  try {
    const url = `${INCENTIVE_MONTHLY.GET_MONTHLY_THREE_DETAILS}/${incentiveClientDetailsId}/candidates`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
